import { PAGES_TYPES } from 'constants/pagesTypes';

import { aboutUsPartnersPropsData } from './aboutUsData';
import { cloudMigrationPartnersPropsData } from './cloudMigrationData';

export const partnersPropsSelector = {
  [PAGES_TYPES.cloudMigration]: cloudMigrationPartnersPropsData,
  [PAGES_TYPES.aboutUs]: aboutUsPartnersPropsData,
};
